import { Rating, Stack, Button, Chip, Box, Alert } from '@mui/material';
import '../../css/product.css';
import { Edit } from '@mui/icons-material';
import Progress from '../Tools/Progress'
import { Link } from 'react-router-dom';
import AttachmentIcon from '@mui/icons-material/Attachment';
import ZoomIcon from '@mui/icons-material/ZoomInOutlined';
import ShareIcon from '@mui/icons-material/Share';
import { useContext } from "react"
import ToastContext from "../../services/Context/ToastContext"
import CopyToClipboard from 'react-copy-to-clipboard';
import UserContext from "../../services/Context/UserContext";
import { txt } from '../../services/translation';
import frenchCountries from "../../config/frenchCountries";
import VirtualClassroom from '../Tools/VirtualClassroom';

export default function Course({id, title, subtitle, program, picture, pi, button, rating, onClick, link, badges, completion, docs, dpc, virtualClassroomUrl, alert, shareLink, editable}){

    return <div className='product'>

        <Img id={id} url={picture} pi={pi} editable={editable} />

        <div className='product-content'>

            <Title title={title} subtitle={subtitle} />

            <Flag alert={alert} />

            <Stack direction='row' spacing={1}>

                <Program link={program} />

                <Share link={shareLink} />

            </Stack>

            <Stars rating={rating} />

            <Dpc dpc={dpc} />

            <VirtualClassroom url={virtualClassroomUrl} />

            <Completion value={completion} />

            <Docs link={docs} />

            <Badges values={badges || []} />

        </div>

        <Btn text={button} onClick={onClick} link={link} />

    </div>
}


function Title({title, subtitle}){

    return <span className='product-title'>
        {title}
        <br/>
        <small>{subtitle}</small>
    </span>

}



function Img({id, url, pi, editable}){

    const style = {backgroundImage: `url(${url})`}

    return <div className='product-img' style={style}>

        <div className='product-img-left'>

            {editable ? 
                <Link 
                    className='product-edit' 
                    to={`/design/${id}`}
                >
                    <Edit />
                </Link>
                :
                <div></div>
            }

            {pi && 
                <div className="product-pi">
                    <div className="product-pi-badge">PROGRAMME<br/>INTÉGRÉ DPC</div>
                </div>
            }

        </div>

    </div>
}


function Program({link}){

    return link &&
        <Button
            startIcon={<ZoomIcon />} 
            label="Programme" 
            href={link /*V1*/} 
            target="_blank" 
            rel="noopener noreferrer"
            size='small'
            color='info'
        >
            {txt('program')}
        </Button>
}

function Share({link}){

    const {setToast} = useContext(ToastContext)

    return link &&
        <CopyToClipboard 
            text={link} 
            onCopy={() => setToast({
                severity: 'success',  
                message: txt('copyEnrollmentLinkMessage'),
                duration: 4000
            })}
        >
            <Button
                startIcon={<ShareIcon />} 
                label={txt('shareButton')} 
                size='small'
                color='info'
            >
                {txt('shareButton')}
            </Button>
        </CopyToClipboard>
}


function Stars({rating}){

    return (rating || 0) > 0 && 
        <Stack direction='row' alignItems='center' spacing={1}>

            <Rating 
                value={rating}
                precision={0.5}
                readOnly
            />

            <span>{rating.toFixed(1)}</span>
        </Stack>
}


function Docs({link}){

    return link && <Link to={link}>

        <Chip 
            icon={<AttachmentIcon />} 
            label={txt('documents')} 
            clickable
            variant='outlined'
        />

    </Link>
}



function Badges({values}){

    const {user} = useContext(UserContext)

    if(!frenchCountries.includes(user.country)) return <></>

    if(values.length === 0) return <></>

    return <Stack 
        direction='row' 
        justifyContent='center' 
        flexWrap='wrap'
    >

        {values.map(v => 
            <Chip 
                key={v} 
                label={v} 
                size='small'
                sx={{m: 0.5}}
            />)
        }

    </Stack>
}

function Dpc({dpc}){

    return dpc && <Chip
        label={dpc.shortTitle}
    />
}


function Completion({value}){

    return (typeof value === 'number') &&
        <Box width="100%">
            <Progress value={value}/>
        </Box>

}


function Btn({text, onClick, link}){
    const isExternalLink = link && typeof link === 'string' && link.startsWith('https://');

    const isInternalLink = link && typeof link === 'string' && !link.startsWith('https://');

    const props = {
        sx: { width: '100%', height: 50 },
        color: 'info',
        onClick: onClick || undefined,
        component: isInternalLink ? Link : undefined,
        to: isInternalLink ? link : undefined,
        href: isExternalLink ? link : undefined,
        target: isExternalLink ? '_blank' : undefined,
        rel: isExternalLink ? 'noopener noreferrer' : undefined,
    }

    return <Button {...props}>{text}</Button>
}


function Flag({alert}){

    if(!Array.isArray(alert) || alert.length < 2) return false;

    return <Alert severity={alert[0]} size='small' sx={{p: '0px 10px'}}>{alert[1]}</Alert>
}